export default "__VITE_ASSET__CxKaZX6i__"